import { render, staticRenderFns } from "./office-presentation.component.vue?vue&type=template&id=0b3945bc&scoped=true&lang=html&"
import script from "./office-presentation.component.vue?vue&type=script&lang=js&"
export * from "./office-presentation.component.vue?vue&type=script&lang=js&"
import style0 from "./office-presentation.component.vue?vue&type=style&index=0&id=0b3945bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3945bc",
  null
  
)

export default component.exports